import Axios from 'axios';
import ENV from './env';

export default {

  /**
   * Get brand Master All Advertisers
   */
  getAllAdvertisers() {
    return Axios(`${ENV.ERP_PORT}/api/v1/advertisers`)
    .then((response) => {

      const resultData = response.data;

      const {
        success,
        message,
        data,
      } = resultData;

      return {
        _data: data,
        _success: success,
        _message: message,
      };

    })
    .catch(error => console.log(error));
  },
};



// WEBPACK FOOTER //
// ./src/services/advertiser.js